export const deClientPortalOrderDetailsPagePages = {
    orders: {
        orderDetailsPage: {
            allOrders: 'Alle Aufträge',
            title: 'Auftragsübersicht',
            emptyStateTitle: 'Keine Daten zu diesem Auftrag gefunden',
            options: 'Optionen',
            external: 'Extern',
            save: 'Speichern',
            notSet: 'Noch nicht festgelegt',
            noPurpose: 'Kein Zweck angegeben',
            noInformation: 'Keine Angabe',
            openTasks_one: '{{count}} offene Aufgabe',
            openTasks_other: '{{count}} offene Aufgaben',
            assigneeUser: 'Nutzer/in',
            observers: {
                edit: 'Beobachter bearbeiten',
                stopObserving: 'Auftrag nicht mehr beobachten',
                observe: 'Auftrag beobachten',
                empty: 'Der Auftrag wird aktuell von niemandem beobachtet.',
                header: {
                    protectedTooltip: 'Als Zuständige/r dieses Auftrags beobachten Sie ihn automatisch.',
                    platformUserTooltip: 'Sie können sich als Plattformnutzer nicht als Beobachter hinzufügen.',
                    observingTooltip: 'Sie beobachten diesen Auftrag. Klicken, um nicht mehr zu beobachten.',
                    notObservingTooltip: 'Sie beobachten diesen Auftrag nicht. Klicken, um ihn zu beobachten.',
                    addObserverTooltip: 'Beobachter hinzufügen',
                    observerGroup: 'Beobachter',
                    disableObservationAriaLabel: 'Beobachtung deaktivieren',
                    enableObservationAriaLabel: 'Beobachtung aktivieren',
                },
                drawer: {
                    title: 'Beobachter bearbeiten',
                    addObserversLabel: 'Weitere Beobachter hinzufügen...',
                    observeOrder: 'Auftrag beobachten',
                    observerCount_one: '{{count}} Beobachter des Auftrags',
                    observerCount_other: '{{count}} Beobachter des Auftrags',
                    editObservers: 'Beobachter bearbeiten',
                    responsible: 'Zuständig',
                    responsibleRemoveTooltip: 'Auftragszuständige können nicht als Beobachter/in entfernt werden.',
                    infoTitle: 'Was sind Beobachter?',
                    infoText:
                        'Beobachter werden per Mail über alle Neuigkeiten zu einem Auftrag informiert, die sie in ihren Benachrichtigungseinstellungen aktiviert haben. Dazu zählen u.A.: Änderungen des Auftragsstatus, verfügbare Entwürfe, neue Nachrichten und Aufgabenupdates.',
                    notificationSettings: 'Zu den Benachrichtigungseinstellungen',
                },
            },
            sections: {
                assignees: 'Zuständige',
                externalContacts: 'Externe Kontakte',
                orderData: 'Auftragsdaten',
                report: 'Gutachten',
            },
            mandatorList: {
                addButton: 'Auftraggeber hinzufügen',
                addModalTitle: 'Auftraggeber hinzufügen',
                item: {
                    edit: 'Bearbeiten',
                    delete: 'Löschen',
                    editModalTitle: 'Auftraggeber bearbeiten',
                },
                form: {
                    name: 'Name',
                    street: 'Straße',
                    houseNumber: 'Hausnummer',
                    zip: 'Postleitzahl',
                    city: 'Stadt',
                    country: 'Land',
                },
            },
            contactList: {
                addButton: 'Kontakt hinzufügen',
                addModalTitle: 'Kontakt hinzufügen',
                item: {
                    edit: 'Bearbeiten',
                    delete: 'Löschen',
                    editModalTitle: 'Ansprechpartner bearbeiten',
                },
                form: {
                    salutation: 'Anrede',
                    salutationOptions: {
                        mr: 'Herr',
                        ms: 'Frau',
                        dr: 'Dr.',
                        mrDr: 'Herr Dr.',
                        msDr: 'Frau Dr.',
                        placeholder: 'Anrede auswählen',
                    },
                    name: 'Vorname und Nachname',
                    role: 'Rolle',
                    company: 'Firma',
                    street: 'Straße',
                    houseNumber: 'Hausnummer',
                    zip: 'Postleitzahl',
                    city: 'Stadt',
                    email: 'E-Mail',
                    invalidEmail: 'Keine gültige E-Mail',
                    phoneNumber: 'Telefonnummer',
                    invalidPhoneNumber: 'Keine gültige Telefonnummer',
                    note: 'Anmerkung / Wann soll diese Person kontaktiert werden?',
                    infoBox:
                        'Alle Felder sind optional, bitte geben Sie nur die persönlichen Informationen an welche für eine Kontakaufnahme nötig sind.',
                },
            },
            customerAssignment: {
                addButton: 'Kund/in hinzufügen',
                modalTitle: 'Zuständige Kund/innen',
                cancel: 'Abbrechen',
                duplicateWarning: 'Dieselbe/r Kund/in wurde mehrfach ausgewählt. Bitte ändern Sie einen der Einträge.',
                assigneeLabel: 'Zuständige/r Kund/in',
                removeTooltip: 'Entfernen',
                addMore: 'Weitere hinzufügen',
            },
            assetBox: {
                goToAsset: 'Zur Immobilie',
                imageAlt: 'Bild der Immobilie',
            },
            contacts: {
                emptyState: 'Fügen Sie die Kontaktdaten externer Beteiligter hinzu, bspw. für die Besichtigung.',
            },
            orderData: {
                costCenter: 'Kostenstelle',
                additionalInformation: 'Zusätzliche Informationen',
                valuationReason: 'Auftragszweck',
                orderDate: 'Auftragsdatum',
                dueDate: 'Fertigstellungsdatum',
                dueDateFallback: 'Gemäß vertraglicher Vereinbarung',
                dueDateTooltip:
                    'Das Fertigstellungsdatum ist vorläufig und kann sich unter Umständen ändern. Sie werden über Änderungen per E-Mail benachrichtigt.',
                valuationDate: 'Wertermittlungsstichtag',
                usageType: 'Nutzungsart',
                assetState: 'Bewertungszustand',
                appraiserOffice: 'Gutachterbüro',
                inspectionDate: 'Besichtigungsdatum',
                qualityAssessmentDate: 'Qualitätsstichtag',
                reportDate: 'Gutachtendatum',
            },
            tasks: {
                allTasks: 'Alle Aufgaben',
                addTaskTooltip: 'Aufgabe hinzufügen',
                createTask: 'Aufgabe erstellen',
                status: {
                    open: 'Offen',
                    done: 'Abgeschlossen',
                },
                preview: {
                    showMore: 'Mehr anzeigen',
                    showLess: 'Weniger anzeigen',
                },
                emptyState:
                    'Erstellen Sie Aufgaben für Sie selbst und Andere, bspw. Upload bestimmter Dokumente oder Besichtigungskoordination.',
            },
            messages: {
                allThreads: 'Alle Unterhaltungen',
                addConversationTooltip: 'Unterhaltung hinzufügen',
                startConversation: 'Unterhaltung starten',
                emptyState: 'Starten Sie eine Unterhaltung, um Fragen zu klären, Unterstützung zu erhalten oder Informationen zu teilen.',
                preview: {
                    showMore: 'Mehr anzeigen',
                    showLess: 'Weniger anzeigen',
                    noTitle: 'Kein Titel',
                    noMessagesInThread: 'Noch keine Nachrichten in dieser Unterhaltung',
                    notifiedUsersTooltip:
                        'Über neue Nachrichten wird aktuell niemand benachrichtigt. Hier klicken, um Benachrichtigte hinzuzufügen.',
                    thread: {
                        noMessages: 'Keine Nachrichten',
                        deletedMessage: 'Nachricht wurde gelöscht',
                        createdBy: 'Unterhaltung wurde von {{userName}} angelegt',
                        createdAutomatically: 'Die Unterhaltung wurde automatisch angelegt',
                    },
                },
            },
            documents: {
                edit: 'Dokumente bearbeiten',
                add: 'Dokumente hinzufügen',
                downloadAll: 'Alle herunterladen',
                emptyText:
                    'Stellen Sie Dokumente für diesen Auftrag zur Verfügung. Aufgabendokumente und Nachrichtenanhänge erscheinen hier automatisch.',
                uploadFiles: 'Dateien hochladen',
                modal: {
                    uploadTitle: 'Dokumente hochladen',
                    editTitle: 'Dokumente bearbeiten',
                    createButton: 'Erstellen',
                    confirmButton: 'Bestätigen',
                    cancelButton: 'Abbrechen',
                    dropzonePrompt: 'Datei auswählen oder per Drag & Drop hochladen',
                    nameLabel: 'Name',
                    tagsLabel: 'Tags',
                    unknownMimeTypeLabel: 'Unbekannt',
                    uploadErrorAlert: {
                        title: 'Fehler beim Hochladen der Dateien',
                        description: 'Folgende Dateien konnten nicht erfolgreich hochgeladen werden:',
                        supportText: 'Bitte versuchen Sie es erneut oder schreiben Sie eine Nachricht an support@einwert.com',
                    },
                },
                table: {
                    nameHeader: 'Name',
                    tagsHeader: 'Tags',
                    dateHeader: 'Datum',
                    downloadAction: 'Dokument herunterladen',
                    deleteAction: 'Dokument löschen',
                    deleteModalTitle: 'Dokument löschen',
                    deleteModalPrimaryAction: 'Löschen',
                    deleteModalSecondaryAction: 'Abbrechen',
                    deleteModalDescription: 'Soll das Dokument {{documentName}} wirklich gelöscht werden?',
                },
            },
            images: {
                add: 'Bilder hinzufügen',
                downloadAll: 'Alle herunterladen',
                emptyText: 'Stellen Sie Bilder der Immobilie zur Verfügung.',
                upload: 'Bilder hochladen',
            },
            valuationSection: {
                noDate: 'Kein Datum',
                unknownUser: 'Unbekannt',
                title: {
                    valueCheck: 'Wertüberprüfung',
                    reportsAndDrafts: 'Gutachten und Entwürfe',
                },
                status: {
                    valueCheckFinalised: 'Ihre Wertüberprüfung wurde finalisiert. Hier finden Sie die Detailansicht und das PDF.',
                    valueCheckInProgress: 'Ihre Wertüberprüfung ist noch nicht verfügbar.',
                    fallbackAppraiser: 'Ihr Gutachter/Ihre Gutachterin',
                    finalizedReportReady: 'Ihr finalisiertes Gutachten steht bereit.',
                    approvalReceived: 'hat Ihre Freigabe zur Finalisierung erhalten und wird das finale Gutachten zur Verfügung stellen.',
                    annotationsReceived: 'hat Ihre Anmerkungen erhalten und wird einen neuen Entwurf zur Verfügung stellen.',
                    draftAvailable:
                        'Ihnen wurde ein Entwurf zur Verfügung gestellt. Prüfen Sie den Entwurf mit der Plausibilisierung und erstellen Sie ggf. Anmerkungen.',
                    draftAvailableWithoutPlausibility: 'Ihnen wurde ein Entwurf zur Verfügung gestellt.',
                    noReportsPrefix: 'Keine Gutachten/-entwürfe vorhanden. Warten Sie, bis',
                    noReportsSuffix: 'einen Entwurf oder ein finalisiertes Gutachten übermittelt.',
                },
                card: {
                    reportTitle: 'Wertgutachten {{date}}',
                    valueCheckTitle: 'Wertüberprüfung {{date}}',
                    final: 'Final',
                    draft: 'Entwurf {{count}}',
                    submittedAt: 'Übermittlungsdatum',
                    annotationCount_one: '{{count}} Anmerkung',
                    annotationCount_other: '{{count}} Anmerkungen',
                    noAnnotations: 'Keine Anmerkungen vorhanden',
                    goToPlausibility: 'Zur Plausibilisierung',
                    goToValueCheck: 'Zur Wertüberprüfung',
                    downloadValueCheck: 'Wertüberprüfung herunterladen',
                    goToValuation: 'Zur Bewertung',
                    downloadReport: 'Gutachten herunterladen',
                    goToDraft: 'Zur Entwurfsseite',
                    downloadDraft: 'Entwurf herunterladen',
                },
                handover: {
                    sharedAnnotations: 'Anmerkungen geteilt',
                    sharedBy: 'geteilt von {{userName}}',
                    sharedOn: 'Geteilt am {{date}}',
                    shared: 'geteilt',
                    shareAnnotations: 'Anmerkungen teilen',
                    shareDescription: 'Anmerkungen an Gutachter/in übermitteln und neuen Entwurf anfordern.',
                },
                approvals: {
                    approvedDraft: 'Entwurf freigegeben',
                    approvedBy: 'Freigegeben von',
                    approvedOn: 'freigegeben am {{date}}',
                    approved: 'freigegeben',
                    approveButton: 'Freigeben',
                    approveByFund: 'Freigabe durch Fondspartner erteilen.',
                    approveDraftAndRequestFinalization: 'Freigabe des Entwurfs erteilen und Finalisierung anfordern.',
                    fundSection: 'Freigabe durch Fonds',
                    kvgSection: 'Freigabe durch KVG',
                },
                modal: {
                    cancel: 'Abbrechen',
                },
                appraiserSelection: {
                    title: 'Kein/e Gutachter/in zuständig',
                    description: 'Fügen Sie mindestens einen Gutachter/eine Gutachterin als Beobachter/in hinzu:',
                    loading: 'Lade Gutachter/innen...',
                    empty: 'Keine verknüpften Gutachter/innen für diesen Auftrag verfügbar.',
                    selectLabel: 'Gutachter/in',
                },
                handoverModal: {
                    title: 'Anmerkungen teilen',
                    primaryButton: 'Teilen',
                    imageAlt: 'teilen',
                    makeAnnotationsVisible: 'Alle Anmerkungen zu diesem Entwurf für den Gutachter/die Gutachterin sichtbar machen',
                    requestNewDraft: 'Neuen Entwurf gemäß der Anmerkungen anfordern',
                    infoText:
                        'Sie können weiterhin Anmerkungen zu diesem Entwurf hinzufügen, bearbeiten und löschen. Ihre Gutachterin/Ihr Gutachter wird sofort benachrichtigt.',
                },
                approvalModal: {
                    title: 'Entwurf freigeben',
                    primaryButton: 'Freigeben',
                    imageAlt: 'freigeben',
                    makeAnnotationsVisible: 'Alle Anmerkungen zu diesem Entwurf für den Gutachter/die Gutachterin sichtbar machen',
                    requestFinalizationWithAnnotations: 'Finalisierung des Gutachtens nach Einarbeitung der Anmerkungen anfordern',
                    requestFinalization: 'Finalisierung des Gutachtens anfordern',
                    infoText: 'Sie können nach der Freigabe Anmerkungen nicht mehr zu diesem Entwurf hinzufügen, bearbeiten oder löschen.',
                    confirmationLabel: 'Ich bestätige, dass ich den Entwurf zur Finalisierung freigebe.',
                },
                internalApprovalModal: {
                    title: 'Entwurf freigeben',
                    primaryButton: 'Freigeben',
                    imageAlt: 'freigeben',
                    fundApproval: 'Fondsseitige Freigabe erteilen',
                    confirmationLabel: 'Ich bestätige, dass ich diesen Entwurf freigebe.',
                },
                annotationsInfo:
                    'Ihr Gutachter/Ihre Gutachterin kann Ihre Anmerkungen zu diesem Entwurf nicht sehen, bevor Sie sie mit ihm/ihr teilen.',
            },
            externalAppraiser: {
                addExternal: 'Externe/n hinzufügen',
                maxOneTooltip: 'Es kann nur eine externe Gutachterin/ein externer Gutachter hinterlegt werden.',
                infoTooltip: 'Externe Gutachter/innen ohne Plattformzugang können per E-Mail eingebunden werden.',
                removeAriaLabel: '{{email}} entfernen',
                beta: 'Beta',
                back: 'Zurück',
                cancel: 'Abbrechen',
                remove: 'Entfernen',
                modal: {
                    title: 'Externe/n Gutachter/in hinzufügen',
                    setup: 'Einrichten',
                },
                intro: {
                    external: 'Externe/r',
                    viaEmail: 'über E-Mail',
                    orderEmail: 'Auftragsmail',
                    user: 'Nutzer/in',
                    onPlatform: 'auf Plattform',
                    title: 'Kollaboration ohne Gutachteraccount',
                    description:
                        'Arbeiten Sie über Kanäle hinweg an Aufträgen mit externen Gutachter/innen, ohne die einwert Plattform zu verlassen.',
                    orderEmailPrefix: 'Aufträge erhalten eine',
                    orderEmailHighlight: 'spezifische Auftragsmail-Adresse.',
                    incomingHighlight: 'Eingehende Mails',
                    incomingText: 'werden automatisch in Unterhaltungen importiert und Anhänge hochgeladen.',
                    outgoingHighlight: 'Neue Nachrichten und Unterlagen',
                    outgoingText: 'werden direkt aus der Plattform über die Auftragsmail an Externe versandt.',
                    missingAsset: {
                        title: 'Keine Immobilie verknüpft',
                        descriptionBeforeEmail:
                            'Externe können nicht zu einem Auftrag ohne verknüpfte Immobilie hinzugefügt werden. Kontaktieren Sie',
                        descriptionAfterEmail: ', um die Immobilie zu verknüpfen.',
                    },
                },
                form: {
                    betaTitle: 'Beta-Feature',
                    betaTextHighlight: 'Es kann nur eine externe Gutachterin/ein externer Gutachter hinterlegt werden.',
                    betaText: 'Ihre Nachrichten und Unterlagen werden also nur an eine Adresse gesendet.',
                    emailTextHighlight: 'Nur E-Mails von der hinterlegten Adresse sind zugelassen',
                    emailText: 'und werden automatisch verarbeitet, wenn sie an die Auftragsmailadresse gesendet werden.',
                    title: 'Externe/n hinterlegen',
                    description:
                        'Hinterlegen Sie die Daten des Gutachters/der Gutachterin, um eingehende Mails für die automatische Verarbeitung zuzulassen.',
                    organization: 'Unternehmen',
                    requiredField: 'Pflichtfeld',
                    invalidEmail: 'Keine gültige E-Mail',
                    lockedInfo: 'Sie können diese Angaben nach dem Speichern nicht mehr bearbeiten.',
                    invitationNotice: {
                        title: 'Einladung wird direkt versendet',
                        description:
                            'Beim Anlegen wird eine Einladung mit der Auftragsmailadresse und dem Link zum Datenraum an die hinterlegte E-Mail-Adresse gesendet.',
                    },
                    salutationOptions: {
                        mr: 'Herr',
                        ms: 'Frau',
                        dr: 'Dr.',
                        placeholder: 'Anrede auswählen',
                    },
                },
                delete: {
                    title: 'Externe/n Gutachter/in entfernen',
                    infoTitle: 'Externe/r wird nicht informiert',
                    infoText: 'Der/die externe Gutachter/in wird über diese Änderung nicht benachrichtigt.',
                    futureEmailsStart: 'Zukünftig eingehende Mails von',
                    futureEmailsEnd: 'werden nicht mehr in den Auftrag importiert und sind nicht mehr für Sie einsehbar.',
                    listImport: 'werden nicht mehr in den Auftrag importiert',
                    listVisible: 'sind nicht mehr für Sie einsehbar',
                    irreversible: 'Diese Aktion kann nicht rückgängig gemacht werden.',
                },
            },
        },
    },
}
